import React from "react";

function Copyright() {
  return (
    <div className="copyrightDiv">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 text-center">
            <h4>&#169; 2022, Masters Computer Enterprise</h4>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Copyright;
